import { api } from '@/core/api/';

const baseURL = 'api/va';

const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export const uploadTicketFile = (payload) =>
  api.post(`${baseURL}/uploadticketfile`, payload, header);
